import { createSlice } from "@reduxjs/toolkit"
import { createAppAsyncThunk } from "app/hooks"
import paymentAPI from "./paymentAPI"
import {
  FIRST_REMAINING_LOG_MEAL_TIME_TO_SHOW_PAYWALL,
  resetStoreAction,
} from "config"
import { IPaymentState } from "./types"

export const getPlans = createAppAsyncThunk(
  "payment/getPlans",
  async (_, { rejectWithValue }) => {
    try {
      const response = await paymentAPI.getPlans()
      return response
    } catch (err: any) {
      return rejectWithValue(err)
    }
  },
)

export const getUserPlan = createAppAsyncThunk(
  "payment/getUserPlan",
  async (_, { rejectWithValue }) => {
    try {
      const response = await paymentAPI.getUserPlan()
      return response
    } catch (err: any) {
      return rejectWithValue(err)
    }
  },
)

const initialState: IPaymentState = {
  remainingLogMealTimeToShowPaywall:
    FIRST_REMAINING_LOG_MEAL_TIME_TO_SHOW_PAYWALL,

  getUserPlanFailed: undefined,
  getUserPlanLoading: false,
  userPlan: undefined,

  plans: [],
  getPlansLoading: false,
  getPlansFailed: undefined,
}

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setRemainingLogMealTimeToShowPaywall(state, action) {
      state.remainingLogMealTimeToShowPaywall = action.payload
    },
  },
  extraReducers(builder) {
    builder

      .addCase(getUserPlan.pending, (state) => {
        state.getUserPlanLoading = true
        state.getUserPlanFailed = undefined
      })
      .addCase(getUserPlan.fulfilled, (state, action) => {
        state.userPlan = action.payload
        state.getUserPlanLoading = false
      })
      .addCase(getUserPlan.rejected, (state, action) => {
        state.getUserPlanLoading = false
        state.getUserPlanFailed = action.payload
      })

      .addCase(getPlans.pending, (state) => {
        state.getPlansLoading = true
        state.getPlansFailed = undefined
      })
      .addCase(getPlans.fulfilled, (state, action) => {
        state.plans = action.payload
        state.getPlansLoading = false
      })

      .addCase(getPlans.rejected, (state, action) => {
        state.getPlansLoading = false
        state.getPlansFailed = action.payload
      })

      .addCase(resetStoreAction, () => {
        return initialState
      })
  },
})

export const { setRemainingLogMealTimeToShowPaywall } = paymentSlice.actions

export default paymentSlice.reducer
